import axios from 'axios';
import config from '../../../../helpers/config';

export default function determineCoverage(zipCode) {
  const url = `${config.mandiBaseUrl}${config.serviceProvidersApi}?service=1&zip=${zipCode}`;

  return axios.get(url, {
    withCredentials: true,
  });
}
